// extracted by mini-css-extract-plugin
module.exports = {"error":"_4f720283bf--error--Ksh0I"};